document.addEventListener('alpine:init', () => {
	Alpine.data('toast', (duration) => ({
		show: false,

		init() {
			this.$nextTick(() => { this.show = true; });
			if (duration > 0) {
				setTimeout(() => this.dismiss(), duration);
			}
		},

		dismiss() {
			this.show = false;
			// Remove after the leave transition so the node doesn't linger.
			setTimeout(() => this.$el.remove(), 200);
		},
	}));
});
